import { render, staticRenderFns } from "./upload-document.component.vue?vue&type=template&id=87ce4e18&"
import script from "./upload-document.component.vue?vue&type=script&lang=ts&"
export * from "./upload-document.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports